<template>
  <div class="account">
    <adx-signup v-if="isSignupModal" @toggle="toggle" />
    <adx-signin v-if="isSigninModal" @toggle="toggle" />
    <adx-forgot v-if="isForgotModal" @toggle="toggle" />
    <adx-social v-if="isSocial" @toggle="toggle" :data="socialData" />
  </div>
</template>

<script>
import Vue from "vue";

import Signin from '@/components/Account/Signin'
import Signup from '@/components/Account/Signup'
import Forgot from '@/components/Account/Forgot'
import Social from '@/components/Account/Social'


export default {
  name: 'adx-account',
  components: {
    'adx-signin': Signin,
    'adx-signup': Signup,
    'adx-forgot': Forgot,
    'adx-social': Social
  },
  props: {

  },
  data() {
    return {
      isSigninModal: false,
      isSignupModal: false,
      isForgotModal: false,
      isSocial: false,
      socialData: undefined
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("openSignin", this.toggleSignin.bind(this))
      Vue.$broker.$on("openSignup", this.toggleSignup.bind(this))
    })
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle(sender, response) {
      switch(sender) {
        case 'gotoSignup':
          this.toggleSignin()
          this.toggleSignup()
          break;
        case 'gotoSignin':
          this.toggleSignup()
          this.toggleSignin()
          break;
        case 'toggleSignin':
          this.toggleSignin()
          break;
        case 'toggleSignup':
          this.toggleSignup()
          break;
        case 'toggleSocial':
          this.toggleSocial()
          break;
        case 'gotoForgotFromSignin':
          this.toggleSignin()
          this.toggleForgot()
          break;
        case 'toggleForgot':
          this.toggleForgot()
          break;
        case 'gotoSigninFromForgot':
          this.toggleForgot()
          this.toggleSignin()
          break;
        case 'gotoSigninFromSocial':
          this.toggleSocial()
          this.toggleSignin()
          break;
        case 'gotoSocialFromSignin':
          this.socialData = response
          this.toggleSignin()
          this.toggleSocial()
          break;
      }
    },
    toggleSignin(sender) {
      if(sender == this) return

      this.isSigninModal = !this.isSigninModal
    },
    toggleSignup() {
      this.isSignupModal = !this.isSignupModal
    },
    toggleForgot() {
      this.isForgotModal = !this.isForgotModal
    },
    toggleSocial() {
      this.isSocial = !this.isSocial
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>